<script>
  import { emitter } from '@/main.js';
  import { whenFastSimonReady } from '@/lib/vue-helpers.js';
  import PDPaddToCartButton from '@/components/PDPaddToCartButton.vue';
  export default {
    name: 'PDPaddToCart',
    components: {
      PDPaddToCartButton
    },
    data() {
      return {
        addToCartText: '',
        UnavailableText: '',
        SoldOutText: '',
        variantId: '',
        parentId: '',
        variantPrice: '',
        handle: '',
        instock: false,
        countryCode: '',
        currencyCode: '',
        loading: false,
        notavail: false,
        hideButton: false,
        showWidget: false,
        success: false,
        showingForm: true,
        error: false,
        compare: '',
        variantPriceNumber: '',
        formEmail: '',
        formEmailList: '',
        formEmailListId: '',
        emailFormValidationError: false,
        comingsoon_tag: '',
        comingsoonText: '',
        comingSoonProduct: false,
        klaviyoEnabled: false,
        joinMessage: '',
        NotifyMeSuccess: '',
        NotifyMeText: '',
        enable_klaviyo: false,
        klaviyo_key: '',
        gwpEnabled: window.siteGlobals.gwpEnabled,
        gwpTag: window.siteGlobals.gwpTag,
        gwpProduct1: window.siteGlobals.gwpProduct1,
        gwpProduct2: window.siteGlobals.gwpProduct2,
        gwpProduct3: window.siteGlobals.gwpProduct3,
        gwpProduct4: window.siteGlobals.gwpProduct4,
        gwpProduct5: window.siteGlobals.gwpProduct5,
        membershipPrice: '',
        useMemberPrice: false,
        localProductId: null,
        localProductHandle: null,
        surface: 'pdp',
        isOutfitPicker: false,
        outfitPickerIndex: null,
        miniPdpHydrated: false,
        productTags: [],
        productTitle: ''
      };
    },
    computed: {
      uid() {
        return `${this.surface}-${this.localProductId || 'default'}`;
      },
      joinMessageId() {
        return `joinMessage-${this.uid}`;
      },
      klaviyoInputId() {
        return `klaviyo-remind-email-auth-input-${this.uid}`;
      },
      klaviyoFormShowing() {
        return this.enable_klaviyo !== 'false' && !!this.variantId && !this.instock && !this.notavail && !this.comingSoonProduct;
      },
      klaviyoFormClass() {
        const formHeight = this.joinMessage === '' ? ' shortForm' : '';
        return (this.klaviyoFormShowing ? 'show-form' : 'hide-form') + formHeight;
      },
      favoriteAllowed() {
        return this.instock && !this.notavail && !this.comingSoonProduct;
      }
    },
    mounted() {
      this.countryCode = window.Shopify.country;
      this.currencyCode = window.Shopify.currency.active;
      this.surface = this.$el.parentElement.getAttribute('data-surface') || 'pdp';
      this.addToCartText = this.$el.parentElement.getAttribute('data-addToCartText');
      this.UnavailableText = this.$el.parentElement.getAttribute('data-UnavailableText');
      this.SoldOutText = this.$el.parentElement.getAttribute('data-SoldOutText');
      this.NotifyMeText = this.$el.parentElement.getAttribute('data-NotifyMeText');
      this.NotifyMeSuccess = this.$el.parentElement.getAttribute('data-NotifyMeSuccess');
      this.joinMessage = this.$el.parentElement.getAttribute('data-joinMessage');
      this.comingsoon_tag = this.$el.parentElement.getAttribute('data-comingsoon_tag');
      this.comingsoonText = this.$el.parentElement.getAttribute('data-comingsoonText');
      this.enable_klaviyo = this.$el.parentElement.getAttribute('data-enable_klaviyo');
      this.klaviyo_key = this.$el.parentElement.getAttribute('data-klaviyo-company-key');
      this.formEmailListId = this.$el.parentElement.dataset.klaviyoListId;
      this.useMemberPrice = this.$el.parentElement.getAttribute('data-use-member-price') === 'true';
      this.localProductId = this.$el.parentElement.getAttribute('data-product-id');
      this.localProductHandle = this.$el.parentElement.getAttribute('data-product-handle');
      this.productTitle = this.$el.parentElement.getAttribute('data-product-title') || '';
      this.applyProductTags(this.parseProductTags(this.$el.parentElement.getAttribute('data-product-tags')));
      if (this.surface !== 'quickview') this.reportDirectProductViewIfApplicable();
      this.isOutfitPicker = this.surface !== 'quickview' && (this.$el.getAttribute('data-is-outfit-picker') === 'true' || this.$el.parentElement.getAttribute('data-is-outfit-picker') === 'true');
      const rawOutfitIdx = this.$el.getAttribute('data-outfit-picker-index') || this.$el.parentElement.getAttribute('data-outfit-picker-index');
      this.outfitPickerIndex = rawOutfitIdx !== null && rawOutfitIdx !== undefined && rawOutfitIdx !== '' ? Number(rawOutfitIdx) : null;

      if (this.enable_klaviyo !== 'false') {
        this.checkIfKlaviyoLoaded();
      }

      if (this.surface === 'quickview') {
        this.initQuickviewVariant();
      }

      if (this.surface === 'mini-pdp') {
        this.initMiniPdpVariant();
      }

      emitter.on('updateUpsellVariantId', this.handleUpsellVariantUpdate);
      emitter.on('updateAddButton', this.handleAddButtonUpdate);
      const initialPayload = typeof window !== 'undefined' ? window.__pdpAddButtonPayload : null;
      if (initialPayload && this.surface !== 'mini-pdp') {
        this.handleAddButtonUpdate(initialPayload);
      }

      this.handleMembershipPriceUpdate = e => {
        const { formattedMembershipPrice, shouldShowMemberPrice } = e.detail;

        if (shouldShowMemberPrice) {
          this.membershipPrice = formattedMembershipPrice;
        } else {
          this.membershipPrice = null;
        }
      };
      window.addEventListener('membershipPriceUpdated', this.handleMembershipPriceUpdate);

      emitter.on('pdp-tags-updated', this.handlePdpTagsUpdated);
      emitter.on('updateEmailError', this.handleUpdateEmailError);
      emitter.on('updateSuccessState', this.handleUpdateSuccessState);
      emitter.on('cart-added', this.handleCartAdded);
    },
    updated() {
      this.syncFavoriteVisibility();
    },
    unmounted() {
      window.removeEventListener('membershipPriceUpdated', this.handleMembershipPriceUpdate);
      emitter.off('updateUpsellVariantId', this.handleUpsellVariantUpdate);
      emitter.off('updateAddButton', this.handleAddButtonUpdate);
      emitter.off('pdp-tags-updated', this.handlePdpTagsUpdated);
      emitter.off('updateEmailError', this.handleUpdateEmailError);
      emitter.off('updateSuccessState', this.handleUpdateSuccessState);
      emitter.off('cart-added', this.handleCartAdded);
      if (this._quickviewForm && this._quickviewVariantHandler) {
        this._quickviewForm.removeEventListener('theme:variant:change', this._quickviewVariantHandler);
      }
    },
    methods: {
      syncFavoriteVisibility() {
        if (this.surface !== 'pdp') return;
        const row = this.$el.parentElement?.closest('.pdp-cta-row');
        if (!row || !row.querySelector('[data-pdp-favorite]')) return;
        row.classList.toggle('pdp-cta-row--atc-no-favorite', !this.favoriteAllowed);
      },
      reportDirectProductViewIfApplicable() {
        if (!this.localProductId) return;
        const findingMethod = localStorage.getItem('findingMethod') || '';
        const fsSourcePatterns = ['PLP:', 'Search Results', 'Complete The Look', 'Recently Viewed', 'Cart Recommendations', 'PDP Recommendation:', 'Collection Slider Recommendation'];
        const isFromFSSource = fsSourcePatterns.some(pattern => findingMethod.includes(pattern));
        if (!isFromFSSource) {
          whenFastSimonReady(() => {
            window.FastSimonSDK.event({
              eventName: window.FastSimonEventName.DirectProductClicked,
              data: {
                productID: String(this.localProductId)
              }
            });
          });
        }
      },
      handleAddButtonUpdate(e) {
        if (!e) {
          return;
        }
        const wrapper = this.$el.parentElement;

        if (this.isOutfitPicker) {
          let localIdx = null;
          if (wrapper) {
            const idxAttr = wrapper.getAttribute('data-outfit-picker-index');
            if (idxAttr !== null && idxAttr !== undefined && idxAttr !== '') {
              localIdx = Number(idxAttr);
            }
          }
          if (localIdx === null || Number.isNaN(localIdx)) {
            try {
              const inner = this.$el.closest('.product__inner');
              const siblings = inner ? Array.from(inner.querySelectorAll('.op-atc')) : [];
              const idx0 = siblings.findIndex(el => el && el.contains(wrapper));
              if (idx0 >= 0) localIdx = idx0 + 1;
            } catch (err) {
              console.error('Failed to derive outfit picker index', err);
            }
          }
          if (localIdx !== null && !Number.isNaN(localIdx)) this.outfitPickerIndex = localIdx;

          if (typeof e.blockIndex === 'undefined') {
            return;
          }
          if (localIdx === null || Number.isNaN(localIdx)) {
            return;
          }
          if (Number(e.blockIndex) !== Number(localIdx)) {
            return;
          }

          try {
            const currentIdAttr = wrapper && wrapper.getAttribute('data-product-id');
            const currentHandleAttr = wrapper && wrapper.getAttribute('data-product-handle');
            if (currentIdAttr) this.localProductId = currentIdAttr;
            if (currentHandleAttr) this.localProductHandle = currentHandleAttr;
          } catch (err) {
            console.error('Failed to read outfit picker product metadata', err);
          }

          this.applyAddButtonUpdate(e);
          return;
        }

        const currentIdAttr = this.$el.parentElement.getAttribute('data-product-id');
        const currentHandleAttr = this.$el.parentElement.getAttribute('data-product-handle');
        if (currentIdAttr) this.localProductId = currentIdAttr;
        if (currentHandleAttr) this.localProductHandle = currentHandleAttr;

        const normalizeId = val => (val ? String(val).replace(/\D+/g, '') : '');
        const normalizeBundleHandle = val => (val ? String(val).replace(/-\d+$/, '') : '');
        const idMatch = normalizeId(e.parentId) && normalizeId(this.localProductId) && normalizeId(e.parentId) === normalizeId(this.localProductId);
        const handleMatch = e.handle && this.localProductHandle && String(e.handle) === String(this.localProductHandle);
        const bundleHandleMatch = e.isBundleProduct && e.handle && this.localProductHandle && normalizeBundleHandle(e.handle) === normalizeBundleHandle(this.localProductHandle);
        const pageHandleMatch = (this.surface === 'pdp' || this.surface === 'mini-pdp') && e.pageHandle && this.localProductHandle && String(e.pageHandle) === String(this.localProductHandle);
        if (!idMatch && !handleMatch && !bundleHandleMatch && !pageHandleMatch) {
          return;
        }

        if (this.surface === 'mini-pdp' && !this.miniPdpHydrated) {
          if (e.notavail && this.instock) {
            return;
          }
          this.miniPdpHydrated = true;
        }

        this.applyAddButtonUpdate(e);
      },
      handleUpsellVariantUpdate(e) {
        this.variantId = e.upsellVariantId;
        this.variantPrice = this.convertToCurrency(e.upsellVariantPrice);
      },
      handlePdpTagsUpdated(e) {
        if (!e || !this.pdpTagsEventMatches(e)) return;
        this.comingSoonProduct = false;
        this.applyProductTags(e.tags);
      },
      pdpTagsEventMatches(e) {
        if (this.isOutfitPicker) {
          if (typeof e.blockIndex === 'undefined') return false;
          return this.outfitPickerIndex !== null && !Number.isNaN(this.outfitPickerIndex) && Number(e.blockIndex) === Number(this.outfitPickerIndex);
        }
        return typeof e.blockIndex === 'undefined';
      },
      parseProductTags(rawTags) {
        try {
          const tags = JSON.parse(rawTags || '[]');
          return Array.isArray(tags) ? tags : [];
        } catch (_) {
          return [];
        }
      },
      applyProductTags(tags) {
        this.productTags = Array.isArray(tags) ? tags : [];
        this.checkComingSoonState(this.productTags);
      },
      handleUpdateEmailError(e) {
        this.emailFormValidationError = e.emailFormValidationError;
      },
      handleUpdateSuccessState(e) {
        this.success = e.success;
      },
      handleCartAdded(e) {
        if (this.surface === 'quickview' && e?.surface === 'quickview') {
          this.closeQuickview();
        }
      },
      checkComingSoonState(tags) {
        (tags || []).forEach(tag => {
          if (tag === this.comingsoon_tag) {
            this.comingSoonProduct = true;
          }
        });
      },
      checkShouldFormShow() {
        if (this.instock) {
          this.showingForm = false;
        }
        if (this.comingSoonProduct) {
          this.showingForm = false;
        }
      },
      checkIfKlaviyoLoaded() {
        if (window.klaviyo) {
          return true;
        }
      },
      applyAddButtonUpdate(e) {
        this.variantId = e.variantId;
        this.parentId = e.parentId;
        this.handle = e.handle;
        this.variantPrice = this.convertToCurrency(e.variantPrice);
        this.instock = e.instock;
        this.notavail = e.notavail;
        this.showWidget = true;
        this.success = false;
        this.showingForm = true;
        this.loading = false;
        this.error = false;
        this.compare = e.comparePrice;
        this.variantPriceNumber = e.variantPrice;
        if (typeof e.productTitle === 'string') this.productTitle = e.productTitle;
        if (Array.isArray(e.tags)) {
          this.comingSoonProduct = false;
          this.applyProductTags(e.tags);
        }
        this.checkShouldFormShow();
      },
      initQuickviewVariant() {
        const wrapper = this.$el.parentElement;
        const variantId = wrapper.getAttribute('data-variant-id');
        const rawPrice = Number(wrapper.getAttribute('data-variant-price')) / 100;
        const available = wrapper.getAttribute('data-variant-available') === 'true';
        const rawCompare = Number(wrapper.getAttribute('data-variant-compare') || 0) / 100;
        const tags = this.parseProductTags(wrapper.getAttribute('data-product-tags'));

        if (variantId) {
          this.applyProductTags(tags);
          this.applyAddButtonUpdate({
            variantId,
            parentId: this.localProductId,
            handle: this.localProductHandle,
            variantPrice: rawPrice,
            instock: available,
            notavail: false,
            comparePrice: rawCompare || '',
            tags
          });
        }

        const form = this.$el.closest('.quickview__form') || this.$el.closest('[data-quickview-form-area]');
        if (form) {
          this._quickviewForm = form;
          this._quickviewVariantHandler = e => {
            const variant = e.detail?.variant;
            if (!variant) {
              this.applyAddButtonUpdate({
                variantId: '',
                parentId: this.localProductId,
                handle: this.localProductHandle,
                variantPrice: 0,
                instock: false,
                notavail: true,
                comparePrice: '',
                tags
              });
              return;
            }
            this.applyAddButtonUpdate({
              variantId: variant.id,
              parentId: String(variant.product_id),
              handle: this.localProductHandle,
              variantPrice: variant.price / 100,
              instock: variant.available,
              notavail: false,
              comparePrice: variant.compare_at_price ? variant.compare_at_price / 100 : '',
              tags
            });
          };
          form.addEventListener('theme:variant:change', this._quickviewVariantHandler);
        }
      },
      initMiniPdpVariant() {
        const wrapper = this.$el.parentElement;
        const variantId = wrapper.getAttribute('data-variant-id');
        const rawPrice = Number(wrapper.getAttribute('data-variant-price')) / 100;
        const available = wrapper.getAttribute('data-variant-available') === 'true';
        const rawCompare = Number(wrapper.getAttribute('data-variant-compare') || 0) / 100;
        const tags = this.parseProductTags(wrapper.getAttribute('data-product-tags'));

        if (variantId) {
          this.applyProductTags(tags);
          this.applyAddButtonUpdate({
            variantId,
            parentId: this.localProductId,
            handle: this.localProductHandle,
            variantPrice: rawPrice,
            instock: available,
            notavail: false,
            comparePrice: rawCompare || '',
            tags
          });
        }
      },
      closeQuickview() {
        const modal = this.$el.closest('[data-quickview-modal]') || this.$el.closest('.modal.is-active');
        if (modal) {
          modal.dispatchEvent(new CustomEvent('theme:quickview:close', { bubbles: true }));
          return;
        }
        const closeBtn = this.$el.closest('[data-api-content]')?.querySelector('[data-micromodal-close]');
        if (closeBtn) closeBtn.click();
      },
      convertToCurrency(str) {
        let dollarUS = Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: this.currencyCode
        });

        let price = dollarUS.format(str).replace('.00', '');

        if (price.includes('CA')) {
          price = price.replace('CA', '');
          price = price + ' CAD';
        }

        return price;
      }
    }
  };
</script>

<template>
  <div v-show="showWidget">
    <div class="klaviyo-collect" :class="klaviyoFormClass">
      <p v-if="emailFormValidationError === true" class="error">The email address is not valid</p>
      <input type="email" class="klaviyo-input" name="klaviyo-remind-email-auth" :id="klaviyoInputId" @focus="emailFormValidationError = false" aria-label="Email" placeholder="Email" required="" v-model="formEmail" />
      <div class="email-checkbox">
        <input type="checkbox" name="klaviyo-email-opt-in" v-model="formEmailList" :aria-labelledby="joinMessageId" />
        <p :id="joinMessageId" v-html="joinMessage"></p>
      </div>
    </div>
    <PDPaddToCartButton ref="atcBtn" :instock="instock" :comingSoonProduct="comingSoonProduct" :success="success" :addToCartText="addToCartText" :comingsoonText="comingsoonText" :variantPrice="variantPrice" :membershipPrice="membershipPrice" :useMemberPrice="useMemberPrice" :soldOutText="SoldOutText" :unavailableText="UnavailableText" :notifyMeText="NotifyMeText" :notavail="notavail" :showingForm="showingForm" :variantId="variantId" :formEmail="formEmail" :loading="loading" :klaviyoFormShowing="klaviyoFormShowing" :klaviyo_key="klaviyo_key" :emailFormValidationError="emailFormValidationError" :formEmailList="formEmailList" :formEmailListId="formEmailListId" :isOutfitPicker="isOutfitPicker" :surface="surface" :productTags="productTags" :productTitle="productTitle" />
    <p v-html="NotifyMeSuccess" class="successMessage" v-if="success"></p>
  </div>
</template>

<style lang="scss">
  .PDPaddToCart[data-enable_klaviyo='true'] .btn--add-to-cart.klaviyo-form-showing-true.stock-false {
    cursor: pointer !important;
    pointer-events: all !important;
  }

  .mini-pdp__wrapper .PDPaddToCart .klaviyo-collect.show-form {
    margin-top: 0;
  }

  .PDPaddToCart {
    .klaviyo-collect {
      transition: all 0.5s ease-in-out;
      max-height: 0;
      margin: 0;
      overflow: hidden;
      &.show-form {
        max-height: 200px;
        margin-top: -20px;
        &.shortForm {
          max-height: 64px;
          .email-checkbox {
            display: none !important;
          }
        }
      }
      .email-checkbox {
        display: flex;
        font-size: 12px;
        margin-bottom: 16px;
        gap: 5px;
        input {
          margin-right: 5px;
        }
      }
    }
    .klaviyo-input {
      color: var(--text);
      border: 1px solid var(--text);
    }
    .successMessage {
      width: 100%;
      text-align: center;
      min-height: 60px;
      line-height: 60px;
      font-size: 24px;
      font-family: var(--GT-FAM-HEADING);
      text-transform: uppercase;
    }

    .ErrorMessage {
      width: 100%;
      font-size: 24px;
      text-align: center;
      color: #ff0000;
    }
    .error {
      width: 100%;
      font-size: 18px;
      text-align: center;
      color: #ff0000;
    }
  }
</style>
